import React, { useEffect }  from 'react';
import WOW from "wowjs";
import { Link } from 'react-router-dom';

function ServiceOne(){
  useEffect(() => {
    const wow = new WOW.WOW({
      live: false, // This disables continuous scanning for new elements
    });
    wow.init();
  }, []);
  
    return(
      <div>
          <div>
            <div className="tmp-services-area services-style--1 bg-working-1 bg_image tmp-section-gap">
              <div className="container">
                {/* <div className="row">
                  <div className="col-lg-12">
                    <div className="section-head">
                      <div className="section-sub-title center-title">
                        <img alt="Business_Consulting_services" src="assets/images/services/section-custom-menubar.png " />
                        <span>
                          OUR SERVICES
                        </span>
                      </div>
                      <h2 className="title split-collab">
                        Our Provided Services
                      </h2>
                    </div>
                  </div>
                </div> */}
                <div className="row g-5">
                  <div className="col-lg-4 col-md-6 col-sm-12 col-12 wow fadeInLeft" data-wow-duration=".8s" data-wow-delay=".1s">
                    <div className="single-services service-style-one">
                      <div className="services-inner  with-shadow  ">
                        <div className="thumbnail">
                          <img
                            alt="Business consulting services"
                            src="assets/images/services/mission1.png"
                          />
                        </div>
                        <div className="services-content">
                          <Link to={"/ServiceDetails"}>
                            <h5 className="title">
                            Mission 
                            </h5>
                          </Link>
                          <p className="desctiption">
                          Our mission is to empower the Vaishnav community by facilitating business development, fostering collaboration, and promoting knowledge-sharing. We are committed to helping our members succeed by providing the resources, guidance, and support needed to grow both professionally and personally. 
                          </p>
                          <Link className="icon angle-roted" to={"/"}>
                            <i className="fa-solid fa-arrow-right" />
                          </Link>
                        </div>
                        <div className="number">
                          {/* <img alt="Business Consulting number" src="assets/images/services/icon-01.png" /> */}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12 col-12 wow fadeInLeft" data-wow-duration=".8s" data-wow-delay=".2s">
                    <div className="single-services service-style-one">
                      <div className="services-inner  with-shadow  ">
                        <div className="thumbnail">
                          <img
                            alt="Business consulting services"
                            src="assets/images/services/vission.png"
                          />
                        </div>
                        <div className="services-content">
                          <Link to={"/ServiceDetails"}>
                            <h5 className="title">
                            Vision 
                            </h5>
                          </Link>
                          <p className="desctiption">
                          We aim to create a thriving global ecosystem of Vaishnav entrepreneurs, businesses, and professionals, built on unity, collaboration, and excellence. Our vision is to foster a self-sustaining community where every member contributes to collective success and growth, helping each other  in their professional journeys. 
                          </p>
                          <Link className="icon angle-roted" to={"/"}>
                            <i className="fa-solid fa-arrow-right" />
                          </Link>
                        </div>
                        <div className="number">
                          {/* <img alt="Business Consulting number" src="assets/images/services/icon-02.png"/> */}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12 col-12 wow fadeInLeft" data-wow-duration=".8s" data-wow-delay=".3s">
                    <div className="single-services service-style-one">
                      <div className="services-inner  with-shadow  ">
                        <div className="thumbnail">
                          <img
                            alt="Business consulting services"
                            src="assets/images/services/values.png"
                          />
                        </div>
                        <div className="services-content">
                          <Link to={"/ServiceDetails"}>
                            <h5 className="title">
                            Values 
                            </h5>
                          </Link>
                          <p className="desctiption">
                          Our core values of integrity, unity, service, excellence, and sustainability guide all that we do. We prioritize honesty and transparency in our interactions, promote collective growth, and encourage our members to contribute to the betterment of society while striving for continuous improvement and innovation. 
                          </p>
                          <Link className="icon angle-roted" to={"/"}>
                            <i className="fa-solid fa-arrow-right" />
                          </Link>
                        </div>
                        <div className="number">
                          {/* <img
                            alt="Business Consulting number"
                            src="assets/images/services/icon-03.png"
                          /> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className="row">
                  <div className="col-lg-12">
                    <div className="services-bottom">
                      <div className="services-bottom-inner">
                        <p className="description">
                          Our success as consultants will depend on the essential rightness of the advice.
                        </p>
                        <p className="description">
                          Want to learn more About us?
                          <button className="btn-simple">
                            Click here
                          </button>
                        </p>
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
      </div>
    )
}


export default ServiceOne





